import queryParameter from "utils/queryParameter"

const TAB_QUERY_PARAM_KEY = "tab"

// Lowercased so that links sent before tabs had slugs (?tab=Activities) still match.
export const tabSlugFromQueryParams = () => queryParameter(TAB_QUERY_PARAM_KEY)?.toLowerCase()
